import { render } from "./product-seo-update.vue?vue&type=template&id=76223f62"
import script from "./product-seo-update.vue?vue&type=script&lang=js"
export * from "./product-seo-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__